<template>
  <div class="card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-md-2 col-6">
          <base-input label="วันที่">
            <flat-picker class="form-control datepicker" v-model="startDate" />
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input label="ถึง">
            <flat-picker class="form-control datepicker" v-model="endDate" />
          </base-input>
        </div>

        <div class="col-md-2 col-6">
          <base-input label="สถานะ">
            <el-select class="select-primary mr-2" v-model="searchStatus">
              <el-option class="select-primary" label="ทั้งหมด" value="" />
              <el-option
                class="select-primary"
                label="รอดำเนินการ"
                value="pending"
              />
              <el-option
                class="select-primary"
                label="รอตรวจสอบ"
                value="checking"
              />
              <el-option
                class="select-primary"
                label="ฝากเงินสำเร็จ"
                value="success"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input
            label="ค้นหา"
            labelClasses="text-white"
            placeholder="ค้นหา ..."
            v-model="searchQuery"
          />
        </div>
        <div class="col-md-2 col-6 search">
          <base-button
            type="default"
            @click="submitSearch()"
            :disabled="loading"
          >
            ค้นหา
          </base-button>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header bg-dark">
          <h3 class="mb-0 text-white">
            รายการฝากทั้งหมด
            <small class="ml-2">({{ dataCount | format(0) }} รายการ)</small>
          </h3>
        </div>
        <el-table
          row-key="id"
          header-row-class-name="thead-light"
          :data="queriedData"
        >
          <el-table-column label="สมาชิก" min-width="200px">
            <div slot-scope="{ row }">
              <router-link
                :to="`/dashboard/members?search=${row.member.phone}`"
              >
                {{ row.member.firstName }} {{ row.member.lastName }}
              </router-link>
              <br />
              {{ row.member.phone }}
            </div>
          </el-table-column>
          <el-table-column
            label="จำนวนเงิน"
            min-width="150px"
            prop="amount"
            sortable
          >
            <div slot-scope="{ row }">{{ row.amount | format }}</div>
          </el-table-column>
          <el-table-column label="จาก" min-width="300px">
            <div slot-scope="{ row }">
              <h5 class="mb-0">
                {{ row.member.bankNumber }}
              </h5>

              <span class="text-dark">
                {{ row.transferFrom | bankName }} ({{ row.transferFrom }})
              </span>

              <span class="d-block text-muted mt-1" v-if="row.remark !== ''">
                {{ row.remark }}
              </span>
              <span class="d-block text-danger" v-if="row.operator !== ''">
                ทำรายการโดย <b>{{ row.operator }}</b>
              </span>
            </div>
          </el-table-column>
          <el-table-column label="วันที่ฝากเงิน" min-width="200px">
            <div slot-scope="{ row }">
              <h5 class="mb-2">
                {{ row.transferTime | moment("DD/MM/YYYY HH:mm:ss") }}
              </h5>
              <h6 class="font-weight-normal text-muted mb-0">
                ดึงรายการ: {{ row.createdAt | moment("DD/MM/YYYY HH:mm:ss") }}
              </h6>
              <h6
                class="font-weight-normal text-muted mb-0"
                v-if="row.status === 'success'"
              >
                อัพเดทยอด: {{ row.updatedAt | moment("DD/MM/YYYY HH:mm:ss") }}
              </h6>
            </div>
          </el-table-column>
          <el-table-column label="สถานะ" align="center" min-width="300px">
            <div slot-scope="{ row }">
              <span class="badge badge-success" v-if="row.status === 'success'">
                ฝากเงินสำเร็จ
              </span>
              <span
                class="badge badge-danger"
                v-else-if="row.status === 'reject'"
              >
                ฝากเงินไม่สำเร็จ
              </span>
              <span
                class="badge badge-primary"
                v-else-if="row.status === 'checking'"
              >
                รอตรวจสอบ
              </span>
              <span class="badge badge-warning" v-else> รอดำเนินการ </span>
            </div>
          </el-table-column>
          <el-table-column align="center" min-width="150px">
            <div slot-scope="{ row }">
              <button
                class="btn btn-warning btn-sm m-1"
                :disabled="loading"
                @click="checkTx(row.id)"
                v-if="row.status === 'checking'"
              >
                ตรวจสอบ
              </button>
              <button
                class="btn btn-danger btn-sm"
                :disabled="loading"
                @click="cancelTx(row.id)"
                v-if="row.status === 'pending'"
              >
                ยกเลิก
              </button>
            </div>
          </el-table-column>
        </el-table>
        <div class="card-footer d-flex justify-content-between">
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>

          <base-pagination
            class="pagination-no-border"
            :per-page="pagination.perPage"
            :total="total"
            v-model="pagination.currentPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, FormItem, Select, Option } from "element-ui";
import { BasePagination } from "../components";
import flatPicker from "vue-flatpickr-component";

import moment from "moment";
import TxService from "../services/tx.service";
import api from "../services";
import tablePagination from "../mixins/tablePagination";
import Swal from "sweetalert2";

export default {
  mixins: [
    tablePagination([
      "member.firstName",
      "member.lastName",
      "member.phone",
      "amount",
      "remark",
      "createdAt",
    ]),
  ],
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
  },
  data() {
    return {
      loading: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      searchStatus: "",

      dataCount: 0,
      tableData: [],
    };
  },
  methods: {
    fetchDeposit() {
      TxService.fetchDeposit({
        start: this.startDate,
        end: this.endDate,
        status: this.searchStatus,
      })
        .then((res) => {
          this.dataCount = res.count;
          this.updateTableData(res.transactions);
        })
        .catch(({ message }) => {
          this.$notify({ type: "danger", message });
        });
    },
    checkTx(txID) {
      Swal.fire({
        icon: "info",
        title: `ยืนยันรายการ #${txID}?`,
        showCancelButton: true,
      }).then(async ({ value }) => {
        if (!value) return false;

        try {
          this.loading = true;
          const res = await api.post(`/transactions/${txID}/check`);

          this.$notify({ type: "success", message: res.message });
          this.fetchDeposit();
        } catch ({ message }) {
          this.$notify({ type: "danger", message });
        } finally {
          this.loading = false;
        }
      });
    },
    cancelTx(txID) {
      Swal.fire({
        icon: "info",
        title: `ยกเลิกรายการ #${txID}`,
        input: "text",
        inputAttributes: {
          placeholder: "หมายเหตุ ...",
        },
        showCancelButton: true,
      }).then(async ({ value = false }) => {
        if (!value && value !== "") return false;

        try {
          this.loading = true;
          const res = await api.post(`/transactions/${txID}/cancel`, {
            remark: value,
          });

          this.$notify({ type: "success", message: res.message });
          this.fetchDeposit();
        } catch ({ message }) {
          this.$notify({ type: "danger", message });
        } finally {
          this.loading = false;
        }
      });
    },
  },
  created() {
    this.fetchDeposit();
  },
  watch: {
    startDate() {
      this.fetchDeposit();
    },
    endDate() {
      this.fetchDeposit();
    },
    searchStatus() {
      this.fetchDeposit();
    },
  },
};
</script>
